// extracted by mini-css-extract-plugin
export var activeLanguage = "footer-module--activeLanguage--575a6";
export var afterFooter = "footer-module--afterFooter--39017";
export var afterLinkColumn = "footer-module--afterLinkColumn--ca555";
export var chatButton = "footer-module--chatButton--991ca";
export var footer = "footer-module--footer--a2fe4";
export var footerLogo = "footer-module--footerLogo--e0013";
export var languages = "footer-module--languages--721fe";
export var linkColumn = "footer-module--linkColumn--bc5fd";
export var linkContainer = "footer-module--linkContainer--3a1be";
export var lowerFooter = "footer-module--lowerFooter--629ae";
export var lowerFooterLinks = "footer-module--lowerFooterLinks--2b280";
export var upperFooter = "footer-module--upperFooter--a4864";
export var wechatClose = "footer-module--wechatClose--86325";
export var wechatContainer = "footer-module--wechatContainer--e2b77";
export var wechatInfo = "footer-module--wechatInfo--ef6cc";
export var wechatOuter = "footer-module--wechatOuter--b6ee8";